<template>
    <div class="relative group/media w-full max-w-sm rounded-xl overflow-hidden shadow-sm bg-black border border-gray-200/20">
        <video 
            :src="attachment.url" 
            controls 
            class="w-full max-h-64 object-contain"
            @play="$emit('play', $event)"
        >
            Your browser does not support the video tag.
        </video>
        <!-- Fullscreen/Expand overlay trigger -->
        <button 
            @click.prevent="$emit('open-lightbox', attachment.url)"
            class="absolute top-3 right-3 p-1.5 bg-black/40 hover:bg-black/60 text-white rounded-lg opacity-0 group-hover/media:opacity-100 transition-all backdrop-blur-sm"
            title="Open in Fancybox"
        >
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ChatVideo',
    props: {
        attachment: { type: Object, required: true }
    },
    emits: ['play', 'open-lightbox']
};
</script>
